import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import { Loading, InputCustom, HttpError } from "../../components"
import { LoadModalWithLabel } from "../modais"
import * as ApiHelper from "../../ApiHelper"
import Util from "../../Util"
class NotaForm extends Component {
  constructor() {
    super()
    this.fillFields = this.fillFields.bind(this)
    this.getInitialInfo = this.getInitialInfo.bind(this)
    this.sendForm = this.sendForm.bind(this)
    this.onChangeObservacao = this.onChangeObservacao.bind(this)
    this.onChangeQuantidade = this.onChangeQuantidade.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.state = {
      itemDeContrato: "",
      notaFiscal: "",
      observacao: "",
      quantidade: "",
      quantidadeLabel: "",
      valorUnitario: "",
      showForm: false,
      showLoad: false
    }
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }

  componentWillMount() {
    this.getInitialInfo()
  }
  fillFields(fields) {
    var currentFields = {
      itemDeContrato: fields.item_de_contrato.id,
      notaFiscal: fields.nota_fiscal_id,
      observacao: fields.observacao,
      quantidade: parseFloat(fields.quantidade),
      quantidadeLabel: fields.quantidade,
      valorUnitario: fields.valor_unitario,
      showForm: true
    }
    this.setState(currentFields)
  }
  getInitialInfo() {
    ApiHelper.getItemNotaEdit(this.props.itemID, (item, error) => {
      if (item) {
        this.fillFields(item)
        window.scrollTo(0, 0)
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  onChangeObservacao(event) {
    var newValue = event.target.value
    this.setState({
      observacao: newValue
    })
  }
  onChangeQuantidade(event) {
    var newValue = event.target.value
    this.setState({
      quantidade: parseFloat(newValue)
    })
  }
  sendForm(event) {
    event.preventDefault()
    var itemID = this.props.itemID
    var params = {
      quantidade: this.state.quantidade,
      observacao: this.state.observacao,
      itens_de_contrato_id: this.state.itemDeContrato,
      nota_fiscal_id: this.state.notaFiscal,
      valor_unitario: this.state.valorUnitario
    }
    this.toggleLoadModal()
    ApiHelper.updateItemNota(itemID, params, error => {
      this.toggleLoadModal()
      if (error) {
        this.handleErrors(error)
      } else {
        this.props.callBackItem()
      }
    })
  }
  handleErrors(errors) {
    var errorsJSON = JSON.parse(errors)
    var errorsValue = errorsJSON.erros
    var errorsState = {}
    for (var key in errorsValue) {
      errorsState[key + "Error"] = errorsValue[key][0]
    }
    this.setState(errorsState)
  }
  render() {
    if (this.state.httpError) {
      return (
        <div className="container-fluid">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </div>
      )
    }
    return (
      <div className="card">
        <LoadModalWithLabel
          label="Aguarde..."
          onClose={this.toggleLoadModal}
          show={this.state.showLoad}
        />
        <div className="card-header" data-background-color="as-blue">
          <h4 className="title">Editar item da nota fiscal</h4>
          <p className="category">
            Item no valor de{" "}
            {this.state.quantidadeLabel * this.state.valorUnitario}
          </p>
        </div>
        <div className="card-content">
          {this.state.showForm === false && <Loading />}
          {this.state.showForm === true && (
            <div>
              <div className="row">
                <InputCustom
                  error={this.state.quantidadeError}
                  onChange={this.onChangeQuantidade}
                  type="number"
                  sizeClass="col-md-7"
                  label="Quantidade"
                  value={this.state.quantidade.toFixed(4)}
                />
              </div>
              <div className="row">
                <InputCustom
                  onChange={this.onChangeObservacao}
                  type="text"
                  sizeClass="col-md-7"
                  label="Observação"
                  value={this.state.observacao}
                />
              </div>
              <span className="label label-rose">
                Valor do item:{" "}
                {Util.formatCurrency(
                  this.state.quantidade * this.state.valorUnitario
                )}
              </span>
            </div>
          )}
        </div>
        <button
          onClick={this.sendForm}
          type="submit"
          className="btn btn-primary pull-left"
          data-background-color="as-blue"
        >
          Salvar
        </button>
      </div>
    )
  }
}
export default withRouter(NotaForm)



// WEBPACK FOOTER //
// ./src/views/modais/ItemNotaForm.js